<template>
  <div>
    <card>
      <div class="card-header-custom">
          <button type="submit" class="btn btn-fill btn-primary mr-2" @click="$router.push('/causes/create')">
            <i class="fa fa-plus"></i> Hinzufügen
          </button>

          <button class="btn btn-success" @click="$router.push('/causes/restore')">
            <i class="fa fa-recycle"></i>
            Gelöschte Gründe
          </button>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <table class="table table-striped">
            <thead>
              <tr>
                <th width="10px">&nbsp;</th>
                <th>Name</th>
                <th>&nbsp;</th>
              </tr>
            </thead>
            <draggable v-model="causes" tag="tbody" handle=".handle" @end="updateOrder">
              <tr v-for="cause in causes" :key="cause.id">
                <td class="handle"><i class="fas fa-arrows-alt-v"></i></td>
                <td v-text="cause.name"></td>
                <td class="text-right">
                  <div class="td-actions" v-if="cause.is_editable">
                    <a v-tooltip.top-center="'Bearbeiten'" class="btn btn-warning btn-link btn-xs"
                      @click="editCause(cause)">
                      <i class="fa fa-edit"></i>
                    </a>
                    <a v-tooltip.top-center="'Löschen'" class="btn btn-danger btn-link btn-xs"
                      @click="deleteCause(cause)">
                      <i class="fa fa-close"></i>
                    </a>
                  </div>
                </td>
              </tr>
            </draggable>
          </table>
        </div>
      </div>
    </card>
  </div>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  components: { draggable },
  data() {
    return {
      causes: []
    }
  },
  methods: {
    editCause(cause) {
      this.$router.push(`/causes/${cause.id}/edit`)
    },
    async deleteCause(cause) {
      if (confirm(`Einheit ${cause.name} wirklich löschen?`)) {
        await this.initCsrf()

        this.$http.delete(`/causes/${cause.id}`).then(({ data }) => {
          this.$notify({
            message: `Grund ${data.name} erfolgreich gelöscht.`,
            type: 'success'
          })
          const index = this.causes.findIndex(({ id }) => data.id === id)
          this.causes.splice(index, 1)
        })
      }
    },
    async updateOrder() {
      await this.initCsrf()

      const causes = this.causes.reduce((causes, cause, idx) => ({ ...causes, [cause.id]: idx }), {})
      this.$http.put(`/causes`, { causes })
    }
  },
  created() {
    this.$http.get('/causes').then(({ data }) => { this.causes = data })
  }
}
</script>
